import { PageOrientation } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";
import { PageSize } from "../packing-slips/packing-slip-builder";
import type {
  PersonalizedSlip,
  PersonalizedSlipSettings,
} from "../personalized-slip/personalized-slip-definition";
import { buildLabelFieldsBlock } from "./label-fields-template";
import { SHIPPING_LABEL_CUSTOM_SECTION_DEFAULT_HEIGHT_INCHES } from "./shipping-label-layout";
import type { ShippingLabelTemplate } from "./shipping-label-template-definition";

export const defaultShippingLabelTemplate: Omit<
  ShippingLabelTemplate,
  "id" | "name" | "updatedAt" | "createdAt"
> = {
  blocks: [buildLabelFieldsBlock()],
  customSectionHeightInches:
    SHIPPING_LABEL_CUSTOM_SECTION_DEFAULT_HEIGHT_INCHES,
};

const SHIPPING_LABEL_SLIP_SETTINGS: PersonalizedSlipSettings = {
  pageLayout: { orientation: PageOrientation.PORTRAIT, size: PageSize.LABEL },
  backgroundColor: "#FFFFFF",
  backgroundImageUrl: "",
  backgroundImageOpacity: 1,
};

export function shippingLabelTemplateAsSlip(
  template: ShippingLabelTemplate,
): PersonalizedSlip {
  return {
    _id: template.id,
    team: "",
    name: template.name,
    createdAt: template.createdAt,
    updatedAt: template.updatedAt,
    blocks: template.blocks,
    globalSettings: SHIPPING_LABEL_SLIP_SETTINGS,
  };
}
